export class LoadAuditHistory {
  static readonly type = '[Audit] LoadAuditHistory';
  constructor(
    public entityName: string,
    public entityId: string,
  ) {}
}

export class LoadRelatedAuditHistory {
  static readonly type = '[Audit] LoadRelatedAuditHistory';
  constructor(
    public entityType: string,
    public relation: string,
    public value: string,
  ) {}
}

export class LoadCompositeAuditHistory {
  static readonly type = '[Audit] LoadCompositeAuditHistory';
  constructor(
    public mainEntityName: string,
    public entityId: string,
    public relatedEntities: { entityName: string; relationKey: string }[],
  ) {}
}

export class ClearAuditHistory {
  static readonly type = '[Audit] ClearAuditHistory';
}
